import { useEffect, useState } from 'react';

/** navigator.onLine only reports whether there is *a* network, not whether the
    tenant is reachable — but it catches the case this app is built for, which is
    a phone in a yard with no signal. Anything finer would need a probe, and a
    probe that fails is indistinguishable from the outage we are documenting. */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);

  return online;
}
